import { createAction, props } from '@ngrx/store';

import { ApiVersion } from 'app/shared/models';

export const preloadApiConfig = createAction('[ApiConfig] Preload ApiConfig');

export const preloadApiConfigSuccess = createAction(
    '[ApiConfig] Preload ApiConfig Success',
    props<{
        identifier: string;
        apiVersion: ApiVersion | undefined;
    }>(),
);

export const registerApiConfig = createAction(
    '[ApiConfig] Register ApiConfig',
    props<{ identifier: string }>(),
);

export const registerApiConfigSuccess = createAction(
    '[ApiConfig] Register ApiConfig Success',
    props<{
        identifier: string;
        apiVersion: ApiVersion;
    }>(),
);

export const registerApiConfigFailure = createAction(
    '[ApiConfig] Register ApiConfig Failure',
    props<{ error: string }>(),
);

export const refreshApiVersion = createAction('[ApiConfig] Refresh Api Version');

export const refreshApiVersionSuccess = createAction(
    '[ApiConfig] Refresh Api Version Success',
    props<{
        apiVersion: ApiVersion;
    }>(),
);

export const refreshApiVersionFailure = createAction('[ApiConfig] Refresh Api Version Failure');

export const resetApiConfig = createAction('[ApiConfig] Reset ApiConfig', (resetBatch = false) => ({
    resetBatch,
}));
